export const headerNav = [
  {
    name: '首页',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页1',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页2',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页3',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页4',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页6',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页7',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页8',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页9',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  }
]

export const navItem = [
  {
    name: '首页',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心'],
    title: '大汉控股集团',
    desc: '大汉控股集团大汉控股集团大汉控股集团大汉控股集团大汉控股集团'
  },
  {
    name: '大汉党建',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心'],
    title: '大汉控股集团1',
    desc: '大汉控股集团大汉控股集团大汉控股集团大汉控股集团大汉控股集团1321'
  },
  {
    name: '新闻中心',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心'],
    title: '大汉控股集团2',
    desc: '大汉控股集团大汉控股集团大汉控股集团大汉控股集团大汉控股集团大汉控股集团大汉控股集团大汉控股集团大汉控股集团2342'
  }
]

export const footerNav = [
  {
    name: '首页',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页1',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页2',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页3',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页4',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页6',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页7',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页8',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  },
  {
    name: '首页9',
    list: ['走进大汉', '新闻中心', '新闻中心', '新闻中心', '新闻中心']
  }
]

export const newsli = [
  '集团新闻', '媒体视角', '大汉公益'
]

export const indexNews = [
  [
    {
      imgurl: 'new1.png',
      title: '走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉',
      date: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'new2.png',
      title: '在24日的最终决战中，侯志慧发挥出色，不但在一向强势',
      date: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'new3.png',
      title: '在24日的最终决战中，侯志慧发挥出色，不但在一向强势',
      date: '2020-01-11',
      link: '#'
    }
  ],
  [
    {
      imgurl: 'new1.png',
      title: '在24日的最终决战中，侯志慧发挥出色，不但在一向强势',
      date: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'new2.png',
      title: '在24日的最终决战中，侯志慧发挥出色，不但在一向强势',
      date: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'new3.png',
      title: '在24日的最终决战中，侯志慧发挥出色，不但在一向强势',
      date: '2020-01-11',
      link: '#'
    }
  ],
  [
    {
      imgurl: 'new1.png',
      title: '在24日的最终决战中，侯志慧发挥出色，不但在一向强势',
      date: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'new2.png',
      title: '在24日的最终决战中，侯志慧发挥出色，不但在一向强势',
      date: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'new3.png',
      title: '在24日的最终决战中，侯志慧发挥出色，不但在一向强势',
      date: '2020-01-11',
      link: '#'
    }
  ]
]

export const comdetailLi = [
  '集团概况', '董事长', '价值主张', '大汉荣誉'
]

export const layoutli = [
  '钢贸', '城建', '教育', '汽贸', '商业'
]

export const indexLayouts = [
  [
    {
      imgurl: 'layout1.png',
      title: '走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉',
      desc: '我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我',
      link: '#'
    },
    {
      imgurl: 'layout2.png',
      title: '中华人民共和国驻美利坚ccc',
      desc: '我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我',
      link: '#'
    },
    {
      imgurl: 'layout3.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚ccc',
      desc: '我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '2020-01-11',
      link: '#'
    }
  ],
  [
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚aaaa',
      desc: '我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉',
      desc: '我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '2020-01-11',
      link: '#'
    }
  ],
  [
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '2020-01-11',
      link: '#'
    }
  ],
  [
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚xxx',
      desc: '我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉走进大汉',
      desc: '我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我是公司简介我',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '2020-01-11',
      link: '#'
    }
  ],
  [
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '2020-01-11',
      link: '#'
    },
    {
      imgurl: 'layout1.png',
      title: '中华人民共和国驻美利坚合众国特命全权大使秦刚已经抵达',
      desc: '2020-01-11',
      link: '#'
    }
  ]
]

export const introduceli = [
  '公司简介', '企业荣誉', '优秀案例', '联系我们'
]

export const mobintroduceli = [
  '公司简介', '企业荣誉', '优秀案例', '联系我们'
]

export const construction = [
  {
    imgUrl: 'jianchaanlitu_01.png',
    title: '2018年8月，大汉集团各单位党支部开展反腐倡廉宣传片《迷失》集中学习及心得分享活动。'
  },
  {
    imgUrl: 'jianchaanlitu_02.png',
    title: '2019年6月1日，大汉集团开展了以“忠诚、干净、担当”为主题的廉政建设教育活动。'
  },
  {
    imgUrl: 'jianchaanlitu_03.png',
    title: '2019年7月23日，大汉集团正式加入中国企业反舞弊联盟。'
  },
  {
    imgUrl: 'jianchaanlitu_04.png',
    title: '2020年9月，大汉集团当选中国企业反舞弊联盟理事单位。'
  },
  {
    imgUrl: 'jianchaanlitu_05.png',
    title: '2020年10月22日，大汉集团召开反腐倡廉教育大会，会议谋布局、定方向，反腐倡廉工作开始走向体系化、规范化、专业化。'
  },
  {
    imgUrl: 'jianchaanlitu_06.png',
    title: '2021年3月，大汉海派项目部原营销总监吴焕、副总监张晓敏等4人因侵占公司财务被判处职务侵占罪。'
  }
]



// WEBPACK FOOTER //
// ./src/assets/jsonData.js